import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

/**
 * Main entry point of the React application.
 * Creates the root of the application and renders the `App` component inside the element with the ID 'root'.
 * 
 * @type {ReactDOM.Root} - The React root object.
 */
const root = ReactDOM.createRoot(document.getElementById('root'));

/**
 * Renders the `App` component inside the element with the ID 'root'.
 * Wrapped in `React.StrictMode` to activate additional checks and warnings during development.
 */
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (e.g., reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
